<small class="text-danger">
  {{mensaje}}
</small>
<table class="table table-sm table-striped table-bordered">
  <tbody>
    @for (validacion of validaciones; track validacion) {
      <tr>
        <td class="text-start">{{validacion}}</td>
      </tr>
    }
  </tbody>
</table>
<div class="text-center">
  <button type="button" ngbAutofocus class="btn btn-outline-secondary btn-sm me-1" (click)="cerrar();">
    <i class="bi bi-x-lg"></i> Cerrar
  </button>
</div>